// Enhanced Product Management Routes
export const PRODUCT_ROUTES = {
  // Main product routes
  ROOT: "/products",
  LIST: "/products",
  CREATE: "/products/new",
  EDIT: "/products/:productId/edit",
  DETAILS: "/products/:productId",

  // Stock Management
  STOCK_MANAGEMENT: "/products/:productId/stock",
  STOCK_TRANSFER: "/products/stock-transfer",
  LOW_STOCK_REPORT: "/products/low-stock",

  // Bulk Operations
  BULK_OPERATIONS: "/products/bulk-operations",
  BULK_UPDATE: "/products/bulk-update",

  // Import/Export
  IMPORT: "/products/import",
  EXPORT: "/products/export",

  // Hallmark Management
  HALLMARK_MANAGEMENT: "/products/:productId/hallmark",
  HALLMARK_VERIFICATION: "/products/hallmark/verify",

  // Pricing
  PRICING_CALCULATOR: "/products/:productId/pricing",
  BULK_PRICING: "/products/bulk-pricing",

  // SEO
  SEO_MANAGEMENT: "/products/:productId/seo",

  // Reports
  PRODUCT_REPORTS: "/products/reports",
  INVENTORY_REPORT: "/products/reports/inventory",
  PRICE_ANALYSIS: "/products/reports/price-analysis",
};

// Product Feature Permissions
export const PRODUCT_PERMISSIONS = {
  VIEW_PRODUCTS: "VIEW_PRODUCTS",
  CREATE_PRODUCTS: "CREATE_PRODUCTS",
  EDIT_PRODUCTS: "EDIT_PRODUCTS",
  DELETE_PRODUCTS: "DELETE_PRODUCTS",
  MANAGE_STOCK: "MANAGE_STOCK",
  TRANSFER_STOCK: "TRANSFER_STOCK",
  BULK_OPERATIONS: "BULK_OPERATIONS",
  IMPORT_EXPORT: "IMPORT_EXPORT",
  MANAGE_HALLMARK: "MANAGE_HALLMARK",
  MANAGE_PRICING: "MANAGE_PRICING",
  MANAGE_SEO: "MANAGE_SEO",
  VIEW_REPORTS: "VIEW_PRODUCT_REPORTS",
};
